module.exports = "/static/assets/ba927aa23603e282704613941acd7d08.png";